import { Application } from '../../clients/aasServerClient.generated';
import * as actionCreators from './actionCreators';
import { ActionTypeNames } from './actions';

export interface State {
    table: Application[];
    all: Application[];
    singleApplication: {
        loaded: boolean;
        saved: boolean;
        application?: Partial<Application>;
    };
}

const initialState: State = {
    all: [],
    singleApplication: {
        application: undefined,
        loaded: false,
        saved: false,
    },
    table: [],
};

type Actions = ReturnType<typeof actionCreators[keyof typeof actionCreators]>;

export default function reducer(state: State = initialState, action: Actions): State {
    switch (action.type) {
        case ActionTypeNames.StoreTableApplications:
            return {
                ...state,
                table: action.applications
            };
        case ActionTypeNames.StoreAllApplications:
            return {
                ...state,
                all: action.applications,
            };
        case ActionTypeNames.ClearSingleApplication:
            return {
                ...state,
                singleApplication: {
                    application: undefined,
                    loaded: false,
                    saved: false,
                },
            };
        case ActionTypeNames.StoreSingleApplication:
            return {
                ...state,
                singleApplication: {
                    application: action.application,
                    loaded: true,
                    saved: false,
                },
            };
        case ActionTypeNames.SavedSingleApplication:
            return {
                ...state,
                singleApplication: {
                    ...state.singleApplication,
                    saved: true,
                }
            };
        default:
            return state;
    }
}
